/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/staub/"

const staub: CommunityData = {
  code: "staub",
  inviteCode: "staub",
  name: "STAUB",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/sta-423`,
  socials: {},
  waitlist: false,
  styles: {
    comingSoon: {
      bgColor: "#54a0ff",
      hero: {
        desktop: `https://media.werz.at/community-assets/staub/mobile-landing-background.mp4?type=video`,
        mobile: `https://media.werz.at/community-assets/staub/mobile-landing-background.mp4?type=video`,
        style: "bg-[#C8C8C8]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-logo.png`,
        mobile: `${S3_PREFIX}web-logo.png`,
        style: "w-[120px] h-[36px] sm:w-[208px] sm:h-[62px] hidden sm:block",
      },
      werzLogoColor: "#191818",
      title: "font-['BLMelodyMedium'] text-[28px] leading-[120%] text-[#000000]",
      text: "font-['BLMelodyBook'] text-[16px] leading-[120%] text-[#000000]",
      button:
        "font-['BLMelodyRegular'] text-[16px] leading-[120%] p-4 bg-[#000000] text-[#ffffff] cursor-pointer w-fit",
      input: {
        base: "font-['BLMelodyBook'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-white text-[#000000]",
        border: "#D4D4D4",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['BLMelodyBook'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['BLMelodyBook'] text-[14px] leading-[120%] text-[#000]",
      skipButton: "font-['BLMelodyBook'] text-[14px] leading-[120%] text-[#8D8D8D] cursor-pointer",
      modal: {
        container: "bg-[#3a8ae6] px-[40px] py-[48px]",
        title: "font-['BLMelodyMedium'] text-[24px] leading-[120%] text-[#000000] text-center",
        text: "font-['BLMelodyBook'] text-[14px] leading-[120%] text-[#8D8D8D] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#000000] bg-white font-['BLMelodyBook'] text-[16px] leading-[120%] text-center",
        otpBorder: "#D4D4D4",
        otpBorderFocus: "#000000",
      },
    },
    global: {
      werzLogoColor: "#000",
      counterColor: "#000",
      logo: {
        src: "https://media.werz.at/community/icon/cmgrvr4u300019k54y8zb8to1.jpg?uploadTime=1760537441462&type=image&v=1762238616236",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[208px] h-[62px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#54a0ff",
      asideBg: "#000000",
      asideStyles: "",
      contentBg: "#54a0ff",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.png`,
      bgMobile: `${S3_PREFIX}web-background-mobile.png`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.png`,
      mainFont: "font-['BLMelodyBook']",
      primaryButton:
        "bg-[#000000] border border-[#000000] px-[18px] py-[18px] !text-[#ffffff] font-['BLMelodyRegular'] !text-[16px] text-left",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#222222]",
      item: "font-['BLMelodyMedium'] text-[16px] text-[#ffffff] text-left gap-x-[10px] text-opacity-50 text-center border-b border-[#222222] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#54a0ff] border border-[#a7a7a7] !pb-8",
      titles: "text-[#000000] font-['BLMelodyMedium'] text-[26px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#000000] font-['BLMelodyBook'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#a7a7a7]",
        sectionTitle:
          "text-[#000000] font-['BLMelodyMedium'] text-[26px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#000000] font-['BLMelodyMedium'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#000000] font-['BLMelodyBook'] text-[14px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#a7a7a7]",
        sectionTitle:
          "text-[#000000] font-['BLMelodyMedium'] text-[26px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#000000] font-['BLMelodyMedium'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#000000] font-['BLMelodyBook'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#000000] font-['BLMelodyBook'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#000000] font-['BLMelodyBook'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#000000] font-['BLMelodyMedium'] text-[22px] text-left leading-[110%]",
        text: "text-[#000000] font-['BLMelodyBook'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#000000] font-['BLMelodyMedium'] text-[26px] text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: "https://media.werz.at/community-assets/staub/web-background-non-member.png",
      bgMobile: "https://media.werz.at/community-assets/staub/web-background-non-member.png",
      bgColor: "#54a0ff",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#54a0ff]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#a7a7a7]",
        name: "text-[#ffffff] font-['BLMelody-Medium'] text-[26px] leading-[28.6px] text-center text-center mt-4 mb-1",
        location:
          "font-['BLMelody-Medium'] leading-[19.8px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#000000] font-['BLMelodyBook'] text-[16px] leading-[120%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#000",
        button:
          "bg-[#ffffff00] border border-[#000000] px-[16px] py-[12px] text-[#000000] font-['BLMelodyRegular'] text-[14px] text-left w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#54a0ff] border border-[#a7a7a7] text-[#000000] font-['BLMelodyBook'] text-[16px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#54a0ff] border border-[#a7a7a7]",
          title: "font-['BLMelody-Medium'] leading-[19.8px] text-[16px] text-left text-center mb-1",
          text: "text-[#000000] font-['BLMelodyBook'] text-[16px] leading-[120%] text-center text-center",
          button:
            "bg-[#ffffff00] border border-[#000000] px-[16px] py-[12px] text-[#000000] font-['BLMelodyRegular'] text-[14px] text-left w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['BLMelody-Medium'] leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#54a0ff] border border-[#a7a7a7]",
          duration: "text-[#000000] font-['BLMelodyBook'] text-[12px] leading-[14.4px] text-left",
          name: "text-[#000000] font-['BLMelody-Medium'] leading-[19.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000",
          media: "overflow-hidden m-2 border border-[#a7a7a7]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#54a0ff] border border-[#a7a7a7]",
          name: "text-[#000000] font-['BLMelody-Medium'] leading-[19.8px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#000000] text-[#ffffff] font-['BLMelody-Medium'] text-[16px] uppercase leading-[17.6px] text-center",
          duration: "text-[#000000] font-['BLMelodyBook'] text-[12px] leading-[14.4px] text-left",
          location: "text-[#000000] font-['BLMelodyBook'] text-[12px] leading-[14.4px] text-left",
          button:
            "bg-[#ffffff00] border border-[#000000] px-[16px] py-[12px] text-[#000000] font-['BLMelodyRegular'] text-[14px] text-left w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#a7a7a7]",
            name: "text-[#000000] font-['BLMelody-Medium'] leading-[17.6px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#000000] font-['BLMelody-Medium'] leading-[17.6px] text-[14px] text-left",
            link: "text-[#000000] font-['BLMelodyBook'] text-[14px] leading-[16.8px] text-left",
            status: "text-[#000000] font-['BLMelodyMedium'] leading-[110%] text-[14px] text-left",
            button:
              "bg-[#ffffff00] border border-[#000000] px-[16px] py-[12px] text-[#000000] font-['BLMelodyRegular'] text-[14px] text-left w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#000000] font-['BLMelodyBook'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#54a0ff] border border-[#a7a7a7] text-[#000000] font-['BLMelodyBook'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['BLMelody-Medium'] leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#54a0ff] border border-[#a7a7a7]",
          name: "text-[#000000] font-['BLMelody-Medium'] leading-[19.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000",
          created: "text-[#000000] font-['BLMelodyBook'] text-[12px] leading-[14.4px] text-left",
          media: "overflow-hidden m-2 border border-[#a7a7a7]",
        },
        seeAllNews:
          "text-[#000000] font-['BLMelodyBook'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#54a0ff] border border-[#a7a7a7] text-[#000000] font-['BLMelodyBook'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['BLMelody-Medium'] leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#54a0ff] border border-[#a7a7a7]",
          coverUrl: "overflow-hidden m-2 border border-[#a7a7a7]",
          duration: "text-[#000000] font-['BLMelodyBook'] text-[12px] leading-[14.4px] text-left",
          liveType: "text-[#000000] font-['BLMelodyBook'] text-[12px] leading-[14.4px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#000000] rounded-full",
          playIconColor: "#FFF",
          playIconBackgroundColor: "#000000",
          playIconBorderColor: "#FFF",
          start: "text-[#000000] font-['BLMelodyBook'] text-[12px] leading-[14.4px] text-left",
          title:
            "text-[#000000] font-['BLMelody-Medium'] leading-[19.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#000000] font-['BLMelodyBook'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#54a0ff] border border-[#a7a7a7] text-[#000000] font-['BLMelodyBook'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['BLMelody-Medium'] leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#54a0ff] border border-[#a7a7a7]",
          name: "text-[#000000] font-['BLMelody-Medium'] leading-[19.8px] text-[16px] text-left",
          triangleIconColor: "#000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#a7a7a7]",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "text-[#000000] font-['BLMelodyBook'] text-[12px] leading-[14.4px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#54a0ff] border border-[#a7a7a7] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#a7a7a7]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#000000] font-['BLMelodyMedium'] text-[26px] text-left leading-[110%]",
        subtitle:
          "text-[#000000] font-['BLMelodyBook'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#000000] border border-[#000000] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['BLMelodyRegular'] !text-[16px] text-left",
        questions: "text-[14px] text-left leading-[120%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#a7a7a7]",
        header: "text-[#000000] font-['BLMelodyMedium'] text-[22px] text-left leading-[110%]",
        text: "text-[#000000] font-['BLMelodyBook'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#a7a7a7]",
        header: "text-[#000000] font-['BLMelodyMedium'] text-[22px] text-left leading-[110%]",
        text: "text-[#000000] font-['BLMelodyBook'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#6d6d6d] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] font-['BLMelodyMedium'] text-[22px] text-left leading-[110%]",
        text: "text-[#000000] font-['BLMelodyBook'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['BLMelodyMedium'] text-[22px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#54a0ff] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ffffff00] border border-[#000000] px-[16px] py-[12px] text-[#000000] font-['BLMelodyRegular'] text-[14px] text-left !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#a7a7a7] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['BLMelodyMedium'] text-[16px] text-left leading-[110%] mb-1",
          description:
            "text-[#000000] font-['BLMelodyBook'] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#000000] font-['BLMelodyMedium'] text-[16px] text-left leading-[110%]",
          quantity: "text-[#000000] font-['BLMelodyRegular'] text-[14px] text-left",
          status: "text-[#000000] font-['BLMelodyMedium'] text-[16px] text-left leading-[110%]",
          counterContainer:
            "bg-[#ffffff00] border border-[#000000] px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#ffffff00] border border-[#000000] px-[16px] py-[12px] text-[#000000] font-['BLMelodyRegular'] text-[14px] text-left !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default staub
